// extracted by mini-css-extract-plugin
export default {"sign":"sign_sign__nGGNe","parentOfPwd":"sign_parentOfPwd__XY816","eye":"sign_eye__i9xeo","labelCheck":"sign_labelCheck__TpPQM","space":"sign_space__uFFV7"};